<template>
  <v-container :fluid="$vuetify.display.mdAndDown ? true : false" class="container-block">
    <v-row justify="center" class="px-6">
      <v-col cols="12" md="11" lg="11">
        <v-row justify="space-between">
          <v-col cols="7" md="7" lg="6">
            <v-row style="flex-wrap: nowrap;">
              <span class="title-text">
                {{ t("$vuetify.contact_page.get_in_touch.title") }}
              </span>
            </v-row>
          </v-col>
          <v-col cols="3" md="3" class="pl-lg-12">
            <span class="text-right">
              {{ t("$vuetify.contact_page.get_in_touch.text_right") }}
            </span>
          </v-col>
        </v-row>
        <v-row justify="end" style="position: relative;">
          <div class="line-white"></div>
          <v-card class="btn-get-touch" @click="OpenContactUsModalActive()">
            {{ t("$vuetify.contact_page.get_in_touch.btn_text") }}
          </v-card>
        </v-row>
        <v-row class="mt-8">
          <v-col cols="12" lg="11" align-self="center" class="px-0 col-btns">
            <v-btn href="mailto:contact@gpartners.md" variant="flat" class="btn-white-flat rounded-pill px-8 px-lg-11"
              :size="$vuetify.display.lgAndUp ? 'x-large' : 'large'">
              contact@gpartners.md
            </v-btn>
            
            <v-btn href="tel:+37378338338" variant="outlined" class="btn-black-outline rounded-pill px-8 px-lg-11"
              :size="$vuetify.display.lgAndUp ? 'x-large' : 'large'">
              +373 78 338 338
            </v-btn>

            <v-btn href="https://www.instagram.com/gpartnersco/" target="_blank" variant="flat"
              class="btn-white-flat rounded-pill px-9 px-lg-11" :size="$vuetify.display.lgAndUp ? 'x-large' : 'large'">
              <v-icon>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.00075 0C5.82806 0 5.55539 0.00950025 4.70205 0.048334C3.85037 0.0873344 3.26903 0.222169 2.76036 0.420004C2.23419 0.62434 1.78785 0.897676 1.34318 1.34251C0.898176 1.78719 0.62484 2.23352 0.419838 2.75953C0.221502 3.26837 0.0865008 3.84987 0.0481671 4.70122C0.01 5.55456 0 5.82739 0 8.00008C0 10.1728 0.00966692 10.4446 0.048334 11.298C0.0875011 12.1496 0.222336 12.731 0.420004 13.2396C0.624507 13.7658 0.897843 14.2121 1.34268 14.6568C1.78719 15.1018 2.23352 15.3758 2.75936 15.5802C3.26837 15.778 3.84987 15.9128 4.70138 15.9518C5.55472 15.9907 5.82723 16.0002 7.99975 16.0002C10.1726 16.0002 10.4444 15.9907 11.2978 15.9518C12.1495 15.9128 12.7315 15.778 13.2405 15.5802C13.7665 15.3758 14.2121 15.1018 14.6567 14.6568C15.1017 14.2121 15.375 13.7658 15.58 13.2398C15.7767 12.731 15.9117 12.1495 15.9517 11.2981C15.99 10.4448 16 10.1728 16 8.00008C16 5.82739 15.99 5.55472 15.9517 4.70138C15.9117 3.84971 15.7767 3.26837 15.58 2.7597C15.375 2.23352 15.1017 1.78719 14.6567 1.34251C14.2116 0.897509 13.7666 0.624173 13.24 0.420004C12.73 0.222169 12.1483 0.0873344 11.2966 0.048334C10.4433 0.00950025 10.1716 0 7.99825 0H8.00075ZM7.28308 1.44168C7.49608 1.44135 7.73375 1.44168 8.00075 1.44168C10.1368 1.44168 10.3899 1.44935 11.2335 1.48768C12.0135 1.52335 12.4368 1.65368 12.7188 1.76319C13.0921 1.90819 13.3583 2.08152 13.6381 2.36152C13.9181 2.64153 14.0915 2.9082 14.2368 3.28153C14.3463 3.5632 14.4768 3.98654 14.5123 4.76655C14.5507 5.60989 14.559 5.86323 14.559 7.99825C14.559 10.1333 14.5507 10.3866 14.5123 11.2299C14.4767 12.01 14.3463 12.4333 14.2368 12.715C14.0918 13.0883 13.9181 13.3541 13.6381 13.634C13.3581 13.914 13.0923 14.0873 12.7188 14.2323C12.4371 14.3423 12.0135 14.4723 11.2335 14.508C10.3901 14.5463 10.1368 14.5547 8.00075 14.5547C5.86456 14.5547 5.61139 14.5463 4.76805 14.508C3.98804 14.472 3.5647 14.3416 3.28253 14.2321C2.9092 14.0871 2.64253 13.9138 2.36252 13.6338C2.08252 13.3538 1.90919 13.0878 1.76385 12.7143C1.65435 12.4326 1.52385 12.0093 1.48835 11.2293C1.45002 10.3859 1.44235 10.1326 1.44235 7.99625C1.44235 5.85989 1.45002 5.60789 1.48835 4.76455C1.52402 3.98454 1.65435 3.5612 1.76385 3.2792C1.90885 2.90586 2.08252 2.63919 2.36252 2.35919C2.64253 2.07919 2.9092 1.90585 3.28253 1.76052C3.56454 1.65052 3.98804 1.52052 4.76805 1.48468C5.50606 1.45135 5.79206 1.44135 7.28308 1.43968V1.44168ZM12.2711 2.77003C11.7411 2.77003 11.3111 3.19953 11.3111 3.72971C11.3111 4.25971 11.7411 4.68972 12.2711 4.68972C12.8011 4.68972 13.2311 4.25971 13.2311 3.72971C13.2311 3.1997 12.8011 2.7697 12.2711 2.7697V2.77003ZM8.00075 3.89171C5.73189 3.89171 3.89237 5.73123 3.89237 8.00008C3.89237 10.2689 5.73189 12.1076 8.00075 12.1076C10.2696 12.1076 12.1085 10.2689 12.1085 8.00008C12.1085 5.73123 10.2694 3.89171 8.00058 3.89171H8.00075ZM8.00075 5.33339C9.47343 5.33339 10.6674 6.52723 10.6674 8.00008C10.6674 9.47276 9.47343 10.6668 8.00075 10.6668C6.5279 10.6668 5.33406 9.47276 5.33406 8.00008C5.33406 6.52723 6.5279 5.33339 8.00075 5.33339Z"
                    fill="#111213" />
                </svg>
              </v-icon>
              Instagram
            </v-btn>

            <v-btn href="https://www.facebook.com/Gpartners.invest/" target="_blank" variant="outlined"
              class="btn-black-outline rounded-pill px-9 px-lg-11"
              :size="$vuetify.display.lgAndUp ? 'x-large' : 'large'">
              <v-icon>
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M16.5009 8.04872C16.5009 3.60326 12.919 -0.000488281 8.50047 -0.000488281C4.08193 -0.000488281 0.5 3.60326 0.5 8.04872C0.5 12.0663 3.42566 15.3963 7.2504 16.0001V10.3754H5.21903V8.04872H7.2504V6.27538C7.2504 4.25805 8.44481 3.14373 10.2723 3.14373C11.1476 3.14373 12.0632 3.30094 12.0632 3.30094V5.2818H11.0543C10.0605 5.2818 9.75054 5.90227 9.75054 6.53882V8.04872H11.9694L11.6147 10.3754H9.75054V16.0001C13.5753 15.3963 16.5009 12.0663 16.5009 8.04872Z"
                    fill="#F6F2E6" />
                </svg>

              </v-icon>
              Facebook
            </v-btn>

            <v-btn href="https://www.rabota.md/ru/companies/g-partners" target="_blank" variant="outlined"
              class="btn-black-outline rounded-pill px-10 px-lg-11"
              :size="$vuetify.display.lgAndUp ? 'x-large' : 'large'">
              Rabota.md
            </v-btn>

            <v-btn href="https://t.me/gpartnersco" target="_blank" variant="outlined" class="btn-black-outline rounded-pill px-10 px-lg-11"
              :size="$vuetify.display.lgAndUp ? 'x-large' : 'large'">
              <v-icon>
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08172 16 0.5 12.4183 0.5 8C0.5 3.58172 4.08172 0 8.5 0C12.9183 0 16.5 3.58172 16.5 8ZM8.78672 5.90599C8.00861 6.22963 6.45346 6.8995 4.1213 7.91558C3.7426 8.06618 3.54421 8.21351 3.52615 8.35757C3.49563 8.60103 3.80052 8.6969 4.21569 8.82745C4.27216 8.8452 4.33068 8.8636 4.39067 8.8831C4.79913 9.01588 5.34859 9.17121 5.63423 9.17738C5.89334 9.18298 6.18253 9.07616 6.5018 8.85692C8.68081 7.38603 9.80563 6.64258 9.87625 6.62655C9.92607 6.61524 9.99511 6.60102 10.0419 6.6426C10.0887 6.68418 10.0841 6.76291 10.0791 6.78404C10.0489 6.9128 8.85212 8.02543 8.23279 8.60121C8.03971 8.78071 7.90276 8.90804 7.87476 8.93712C7.81204 9.00226 7.74812 9.06388 7.68669 9.1231C7.30722 9.48891 7.02265 9.76324 7.70245 10.2112C8.02913 10.4265 8.29055 10.6045 8.55134 10.7821C8.83616 10.9761 9.12023 11.1695 9.48778 11.4105C9.58142 11.4718 9.67086 11.5356 9.75796 11.5977C10.0894 11.834 10.3872 12.0463 10.7551 12.0124C10.9689 11.9928 11.1897 11.7918 11.3018 11.1923C11.5668 9.77545 12.0878 6.70567 12.2082 5.44069C12.2187 5.32986 12.2055 5.18802 12.1948 5.12576C12.1842 5.06349 12.1619 4.97478 12.081 4.90911C11.9851 4.83133 11.8371 4.81493 11.7709 4.8161C11.4701 4.8214 11.0084 4.98192 8.78672 5.90599Z"
                    fill="#F6F2E6" />
                </svg>
              </v-icon>
              Telegram
            </v-btn>

            <v-btn href="https://wa.me/message/E4HQMMGFCACOB1" target="_blank" variant="flat" class="btn-white-flat rounded-pill px-10 px-lg-11"
              :size="$vuetify.display.lgAndUp ? 'x-large' : 'large'">
              <v-icon>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0 7.76C0 3.30112 3.49336 0 8 0C12.5066 0 16 3.30112 16 7.76C16 12.2189 12.5066 15.52 8 15.52C7.19053 15.52 6.41392 15.4131 5.68424 15.2125C5.5424 15.1734 5.39157 15.1845 5.25696 15.2438L3.66907 15.9448C3.25371 16.1282 2.78485 15.8328 2.77093 15.3789L2.72736 13.9558C2.722 13.7805 2.64312 13.6166 2.51245 13.4997C0.95584 12.1076 0 10.0923 0 7.76ZM5.54604 6.3011L3.19604 10.0294C2.97052 10.3872 3.41033 10.7904 3.74724 10.5348L6.27153 8.61899C6.44228 8.48939 6.67825 8.4887 6.84972 8.61731L8.71884 10.0192C9.27969 10.4398 10.0802 10.2921 10.454 9.69902L12.804 5.97067C13.0295 5.61286 12.5897 5.20966 12.2528 5.46534L9.72849 7.3811C9.55772 7.5107 9.32177 7.51139 9.15028 7.38275L7.28121 5.98094C6.72033 5.5603 5.91985 5.70798 5.54604 6.3011Z"
                    fill="#111213" />
                </svg>
              </v-icon>
              Whats App
            </v-btn>

          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <ContactUsModal ref="OpenContactUsModal" />
  </v-container>
</template>

<script>
import { useLocale } from "vuetify";
import ContactUsModal from "../Modals/ContactUsModal.vue";

export default {
  name: "GetInTouch",
  setup() {
    const { t } = useLocale();
    return {
      t,
    };
  },
  components: {
    ContactUsModal,
  },
  methods: {
    OpenContactUsModalActive() {
      this.$refs.OpenContactUsModal.dialog = true;
    }
  }
};
</script>

<style scoped>
.col-btns {
  display: flex;
  flex-wrap: wrap;
  column-gap: 10px;
  row-gap: 16px;
}

.btn-white-flat {
  color: #111213;
  background: #F6F2E6;
  text-transform: inherit;
  font-size: 1.2rem;
  font-weight: 400;
  letter-spacing: -0.03rem;
  transition: 0.7s;
}

.btn-white-flat:hover {
  color: #111213;
  background: #F6F2E6;
}

.btn-black-outline {
  color: #F6F2E6;
  text-transform: inherit;
  font-size: 1.2rem;
  font-weight: 400;
  letter-spacing: -0.03rem;
  transition: 0.7s;
}

.btn-black-outline:hover {
  color: #111213;
  background: #f6f2e6;
}

.line-white {
  position: absolute;
  top: 50%;
  left: 0%;
  transform: translate(0px, -50%);
  width: 100%;
  height: 0px;
  border-top: 1px solid #9A9A9B;
}

.btn-get-touch {
  margin-right: 15vw;
  width: 190px;
  height: 190px;
  background: #F6F2E6;
  color: #111213;
  font-size: 1.1rem;
  letter-spacing: -0.02rem;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}

.text-right {
  color: #F6F2E6;
  letter-spacing: -0.02rem;
  font-size: 1.1rem;
}

.title-text {
  color: #9A9A9B;
  font-size: 6rem;
  line-height: 7rem;
}

.img-icon {
  border-radius: 100%;
}

.subtitle-text {
  color: #9A9A9B;
  font-size: 2.5rem;
  font-weight: 400;
}

@media screen and (min-width: 1400px) {

  .btn-white-flat,
  .btn-black-outline {
    font-size: 1.25rem;
  }


}

@media screen and (max-width: 600px) {
  .btn-get-touch {
    width: 100px;
    height: 100px;
    font-size: .7rem;
  }

  .text-right {
    font-size: 0.65rem;
    line-height: 1rem;
    display: block;
  }

  .subtitle-text {
    font-size: 1.7rem;
    margin-bottom: 10px;
  }

  .title-text {
    font-size: 2.2rem;
    line-height: 3.5rem;
  }

  /* .container-block {
    zoom: .48;
  } */

  .btn-white-flat {
    zoom: .65;
  }

  .btn-black-outline {
    zoom: .65;
  }
}

@media screen and (min-width: 600px) and (max-width: 960px) {
  .title-text {
    font-size: 5rem;
    line-height: 6.5rem;
  }

  .btn-white-flat {
    zoom: 0.9;
  }

  .btn-black-outline {
    zoom: 0.9;
  }
}
</style>

<style></style>
